<template>
  <div class="payment-create main-content">
    <form action="" @submit.prevent="submitPaymentData">
      <div class="page-header">
        <h3 class="page-title">{{ $t('prepayments.invoice_payment') }}</h3>
        <ol class="breadcrumb">

          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/funder/dashboard" >{{ $t('general.home') }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/funder/invoices" >{{ $t('invoices.invoice', 2) }}</router-link>
          </li>

          <li class="breadcrumb-item">{{  $t('prepayments.invoice_payment') }}</li>
        </ol>
        <div class="page-actions header-button-container">
          <base-button
            :loading="isLoading"
            :disabled="isLoading"
            icon="save"
            color="theme"
            type="submit"
            v-if="userType !='funder'">
            {{ $t('prepayments.save_prepayment') }}
          </base-button>
        </div>
      </div>

      <SingleInvoiceRow :fetchData="fetchData" />
      <SingleRequestRow :prepaymentRequest="prepaymentRequest"/>

      <div class="payment-card card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.date') }}</label><span class="text-danger"> *</span>
                <base-date-picker
                  v-model="formData.payment_date"
                  :invalid="$v.formData.payment_date.$error"
                  :calendar-button="true"
                  calendar-button-icon="calendar"
                  @change="$v.formData.payment_date.$touch()"
                />
                <div v-if="$v.formData.payment_date.$error">
                  <span v-if="!$v.formData.payment_date.required" class="text-danger">{{ $t('validation.required') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.prepayment_number') }}</label><span class="text-danger"> *</span>
                <base-prefix-input
                  :invalid="$v.paymentNumAttribute.$error"
                  v-model.trim="paymentNumAttribute"
                  :prefix="paymentPrefix"
                  @input="$v.paymentNumAttribute.$touch()"
                />
                <div v-if="$v.paymentNumAttribute.$error">
                  <span v-if="!$v.paymentNumAttribute.required" class="text-danger">{{ $t('validation.required') }}</span>
                  <span v-if="!$v.paymentNumAttribute.numeric" class="text-danger">{{ $t('validation.numbers_only') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('general.to') }}</label><span class="text-danger"> *</span>
                <base-input
                    :readOnly="true"
                    v-model="formData.customer.name"
                    focus
                    type="text"
                    name="name"
                    tab-index="1"
                  />
              </div>
            </div>
             <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.amount') }}</label><span class="text-danger"> *</span>
                <div class="base-input">
                  <money
                    :class="{'invalid' : $v.formData.amount.$error}"
                    v-model="amount"
                    v-bind="customerCurrency"
                    class="input-field"
                  />
                </div>
                <div v-if="$v.formData.amount.$error">
                  <span v-if="!$v.formData.amount.required" class="text-danger">{{ $t('validation.required') }}</span>
                  <span v-if="!$v.formData.amount.between && $v.formData.amount.numeric && amount <= 0" class="text-danger">{{ $t('validation.payment_greater_than_zero') }}</span>
                  <span v-if="!$v.formData.amount.between && amount > 0" class="text-danger">{{ $t('validation.prepayment_greater_than_due_amount') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('general.comment') }}</label>
                <base-text-area
                  v-model="formData.notes"
                  @input="$v.formData.notes.$touch()"
                />
                <div v-if="$v.formData.notes.$error">
                  <span v-if="!$v.formData.notes.maxLength" class="text-danger">{{ $t('validation.notes_maxlength') }}</span>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group collapse-button-container">
                <base-button
                  :loading="isLoading"
                  icon="save"
                  color="theme"
                  type="submit"
                  class="collapse-button"
                >
                  {{ $t('prepayments.save_prepayment') }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import SingleRequestRow from './SinglePrepaymentRequestRow'
export default {
  components: { MultiSelect ,SingleInvoiceRow, SingleRequestRow},
  mixins: [validationMixin],
  data () {
    return {
      prepaymentRequest:[],
      userType:null,
      formData: {
        customer:{
          name:null,
        },
        invoiceWithAmount:null,
        customer_id: null,
        payment_number: null,
        payment_date: null,
        amount: 0,
        invoice_id: null,
        notes: null,

      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      },
      customer: null,
      invoice: null,

      isLoading: false,
      maxPayableAmount: Number.MAX_SAFE_INTEGER,
      isSettingInitialData: true,
      paymentNumAttribute: null,
      paymentPrefix: '',
      advanceOption:true,
      fetchData:[],
    }
  },
  created(){
    this.loadInvoice()
    this.loadRequest()
  },
  validations () {
    return {
      formData: {
        customer_id:{
          required
        },
        payment_date: {
          required
        },
        amount: {
          required,
          between: between(1, this.maxPayableAmount + 1)
        },
        notes: {
          maxLength: maxLength(255)
        }
      },
      paymentNumAttribute: {
        required,
        numeric
      }
    }
  },
  computed: {
    ...mapGetters('currency', [
      'defaultCurrencyForInput'
    ]),
    ...mapGetters('payment', [
      'paymentModes'
    ]),
    ...mapGetters('userProfile', [
        'user'
    ]),
    amount: {
      get: function () {
        return this.formData.amount / 100
      },
      set: function (newValue) {
        this.formData.amount = newValue * 100
      }
    },
    isEdit () {
      if (this.$route.name === 'prepayments.edit') {
        return true
      }
      return false
    },
    customerCurrency () {
      if (this.customerCurrencyDetail) {
        return {
          decimal: this.customerCurrencyDetail.decimal_separator,
          thousands: this.customerCurrencyDetail.thousand_separator,
          prefix: this.customerCurrencyDetail.symbol + ' ',
          precision: this.customerCurrencyDetail.precision,
          masked: false
        }
      } else {
        return this.defaultCurrencyForInput
      }
    }
  },
  watch: {},
  async mounted () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('prepayment', [
      'fetchCreatePayment',
      'addPayment',
      'updatePayment',
      'fetchEditPaymentData',
      'fetchPrePaymentRequest'

    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
     ...mapActions('LoanRequest', [
      'loanRequestStatus',
    ]),
    invoiceWithAmount (invoice_number, due_amount ) {
      return `${invoice_number} (${this.$utils.formatGraphMoney(due_amount, this.customerCurrencyDetail)})`
    },
    async loadInvoice () {
      if (this.$route.params.id) {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
        if (response.data) {
          this.fetchData =response.data.invoice;
        }
      }
    },
    async loadRequest(){
       if (this.$route.params.id) {
        let res = await this.fetchPrePaymentRequest(this.$route.params.id)
        if (res.data) {
          this.prepaymentRequest =res.data.prepaymentRequest;
        }
      }
    },
    async prepaymentInvoiceStatus(){
      const data = {
          invoice_id: this.$route.params.id,
          request_level:'Prepaid'
        }
      let response = await this.loanRequestStatus(data)
      if (response.data.success) {
          //window.toastr['success'](this.$t('invoices.prepayment_successfully'))
          return true
      }
    },

    async loadData () {
      let data={
        invoice_id:this.$route.params.id
      }
        let response = await this.fetchCreatePayment(data)
        this.formData.invoice_id = response.data.invoice.id
        this.formData.amount=response.data.invoice.due_amount
        this.customerCurrencyDetail=response.data.customerCurrency
        this.formData.invoiceWithAmount   = this.invoiceWithAmount (response.data.invoice.invoice_number, response.data.invoice.due_amount)

        this.formData.customer_id = response.data.invoice.user.id
        this.formData.customer.name = response.data.invoice.user.name


        this.paymentNumAttribute = response.data.nextPaymentNumberAttribute
        this.paymentPrefix = response.data.payment_prefix
        this.formData.payment_date = moment(new Date()).toString()
        this.maxPayableAmount = response.data.invoice.due_amount

      return true
    },
    async submitPaymentData () {

      this.$v.formData.$touch()
      if (this.$v.$invalid) {
          return true
      }

      this.formData.payment_number = this.paymentPrefix + '-' + this.paymentNumAttribute

        let data = {
          ...this.formData,
          payment_date: moment(this.formData.payment_date).format('DD/MM/YYYY')
        }
        this.isLoading = true
        try {
          let response = await this.addPayment(data)
          if (response.data.success) {
            this.prepaymentInvoiceStatus()
           // window.toastr['success'](this.$t('prepayments.created_message'))
            this.$router.push('/funder/invoices')
            this.isLoading = true
            return true
          }
          if (response.data.error === 'invalid_amount') {
            window.toastr['error'](this.$t('invalid_amount_message'))
            return false
          }
          window.toastr['error'](response.data.error)
        } catch (err) {
          this.isLoading = false
          if (err.response.data.errors.payment_number) {
            window.toastr['error'](err.response.data.errors.payment_number)
            return true
          }
          window.toastr['error'](err.response.data.message)
        }

    }

  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
